export const suppressRTLFlip = (style: string): string => `${style} /* @noflip */`;
